module.exports = __webpack_public_path__ + "img/99.4f1bf8b0.jpg";